import useCalculatedOrder from '@store/item/hooks/useCalculatedOrder';

/** 주문 라인에서 옵션이 하나라도 선택된 퍼스널 옵션 그룹만 모은다. */
function useSelectedPersonalOptions() {
    const { orderLines } = useCalculatedOrder();
    return orderLines
        .map((line) => line.personalOptions).flat()
        .filter((og) => og.options.length !== 0);
}

export default useSelectedPersonalOptions;
